// src/lib/screenerFormatters.js
// Extracted from ScreenerPage.jsx (SCREENER-FRAG) — content unchanged, location only.
// Signal color helpers + display value formatters used across screener components.

import { S } from '../constants/screenerConfig';

export function signalColor(signal) {
  if (signal === 'BULLISH')  return S.green;
  if (signal === 'BEARISH')  return S.red;
  return S.amber;
}

export function signalBg(signal) {
  if (signal === 'BULLISH')  return 'rgba(16,185,129,0.12)';
  if (signal === 'BEARISH')  return 'rgba(239,68,68,0.12)';
  return 'rgba(245,158,11,0.12)';
}

export function fmtPrice(v) {
  if (v == null || v === 0) return '—';
  return '$' + Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtChange(v) {
  if (v == null) return '—';
  return (v >= 0 ? '+' : '') + v.toFixed(2) + '%';
}

export function fmtVolume(v) {
  if (!v || v === 0) return '—';
  if (v >= 1_000_000) return (v / 1_000_000).toFixed(1) + 'M';
  if (v >= 1_000)     return (v / 1_000).toFixed(0) + 'K';
  return String(v);
}

export function fmt52W(v) {
  if (v == null) return '—';
  return v.toFixed(0) + '%';
}

export function fmtVolRatio(volume, avgVolume) {
  if (!volume || !avgVolume || avgVolume === 0) return '—';
  const ratio = volume / avgVolume;
  return ratio.toFixed(2) + 'x';
}

export function volRatioColor(volume, avgVolume) {
  if (!volume || !avgVolume) return S.muted;
  const ratio = volume / avgVolume;
  if (ratio >= 1.5) return S.green;
  if (ratio < 0.5)  return S.red;
  return S.muted;
}
